import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Instagram } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const DEFAULTS = {
  tagline: "Curating extraordinary Himalayan adventures for the discerning traveler",
  phone: "+91 8149139073",
  email: "info@trailz.in",
  address: "Baner, Pune, India",
  instagram: "https://www.instagram.com/trailz.in/",
  whatsapp: "https://wa.me/918149139073",
};

const Footer = () => {
  const [footer, setFooter] = useState(DEFAULTS);

  useEffect(() => {
    fetch(`${API_URL}/api/content/site`)
      .then(r => r.json())
      .then(data => { if (data?.footer) setFooter({ ...DEFAULTS, ...data.footer }); })
      .catch(() => {});
  }, []);

  return (
    <footer className="bg-zinc-900 text-white pt-20 pb-8">
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid md:grid-cols-4 gap-12 mb-16">
          <div className="md:col-span-1">
            <h3 className="text-2xl font-serif mb-4">Trailz</h3>
            <p className="text-zinc-400 leading-relaxed text-sm">
              {footer.tagline}
            </p>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-6 text-amber-500">Quick Links</h4>
            <ul className="space-y-3 text-zinc-400">
              <li><Link to="/" className="hover:text-white transition-colors">Home</Link></li>
              <li><Link to="/build-adventure" className="hover:text-white transition-colors">Build Your Adventure</Link></li>
              <li><Link to="/blog" className="hover:text-white transition-colors">Travel Blog</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-6 text-amber-500">Contact Us</h4>
            <ul className="space-y-3 text-zinc-400">
              <li className="flex items-center gap-2">
                <Phone className="w-4 h-4 text-amber-500" />
                <a href={`tel:${footer.phone.replace(/\s/g, '')}`} className="hover:text-white transition-colors">{footer.phone}</a>
              </li>
              <li className="flex items-center gap-2">
                <Mail className="w-4 h-4 text-amber-500" />
                <a href={`mailto:${footer.email}`} className="hover:text-white transition-colors">{footer.email}</a>
              </li>
              <li className="flex items-start gap-2">
                <MapPin className="w-4 h-4 text-amber-500 mt-1" />
                <span>{footer.address}</span>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-6 text-amber-500">Follow Us</h4>
            <div className="flex gap-4">
              {footer.instagram && (
                <a href={footer.instagram} target="_blank" rel="noopener noreferrer"
                   className="w-10 h-10 bg-zinc-800 rounded-full flex items-center justify-center hover:bg-amber-600 transition-colors">
                  <Instagram className="w-5 h-5" />
                </a>
              )}
              {footer.whatsapp && (
                <a href={footer.whatsapp} target="_blank" rel="noopener noreferrer"
                   className="w-10 h-10 bg-zinc-800 rounded-full flex items-center justify-center hover:bg-green-600 transition-colors">
                  <Phone className="w-5 h-5" />
                </a>
              )}
            </div>
          </div>
        </div>

        <div className="border-t border-zinc-800 pt-8 text-center">
          <p className="text-zinc-500 text-sm">
            &copy; {new Date().getFullYear()} Trailz. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
